(function () {
    const relatedtileListingWrap = document.querySelector('.related-postlistings-itemswrap .row');
    let dataTax = '';
    let dataSlug = '';
    const loadMoreButton = document.querySelector('.load-more-button .btn');
    if(loadMoreButton){
        loadMoreButton.addEventListener('click',e =>{
            e.preventDefault();
            const tileSlug = e.target.getAttribute('data-range-slug');
            const dataPage = e.target.getAttribute('data-page');
            let dataID = e.target.getAttribute('data-id');
            e.target.setAttribute('data-page',parseInt(dataPage) + 1);
            e.target.classList.add('hide');
            filterRelatedTiles(dataPage,dataID,tileSlug);
        });
    }
    // Filter product function
    function filterRelatedTiles(page = 1,dataID='',dataSlug = '') {
        relatedtileListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
        let filterData = "";
        filterData +="&relatedTileSlug=" + dataSlug;
        filterData +="&dataID=" + dataID
        // Page data to send in request
        let pageData = "&tilespageNo=" + page;
        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                const loadMoreGif = document.querySelector('#loading');
                const responseData = JSON.parse(request.response);
                if (responseData.data.output === 'no-items') {
                    if(loadMoreGif){
                        loadMoreGif.remove();
                    }
                    responseHtml = '<span class="no-result">No Results Found</span>';
                }
                else {
                    if(loadMoreGif){
                        loadMoreGif.remove();
                    }
                    responseHtml = responseData.data.output;
                    let foundPost = responseData.data.foundPost;
                    if(responseData.data.finalPage){
                        loadMoreButton.classList.add('hide');
                    }else{
                        loadMoreButton.classList.remove('hide');
                    }
                }
                relatedtileListingWrap.innerHTML += responseHtml;
            }
        };
        request.send(
        "action=relatedtileslistings&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            filterData+
            pageData
        );
    }
})();